import { composeBackendUrl } from "@/hooks/useBackendRequest";
import { useEffect, useState } from "react";

const BACKEND_HEALTH_SERVICE_URL = composeBackendUrl("/health");
const HEALTH_CHECK_INTERVAL_IN_MILLISECONDS = 5 * 1000;

type HealthStatus = boolean | null;
type BackendHealthStatus = "OK" | "ERROR" | "DISABLED";
type BackendHealthResponse = {
  hasura?: BackendHealthStatus;
};

function isBackendHealthResponse(value: unknown): value is BackendHealthResponse {
  return value != null && typeof value === "object" && "hasura" in value;
}

const useBackendHealthService = (isEnabled?: boolean) => {
  const [isBackendHealthy, setIsBackendHealthy] = useState<HealthStatus>(null);

  useEffect(() => {
    if (isEnabled ?? true) {
      const checkHealth = async () => {
        try {
          const response = await fetch(BACKEND_HEALTH_SERVICE_URL, {
            cache: "no-store",
          });
          const data: unknown = await response.json();
          setIsBackendHealthy(
            response.ok &&
              isBackendHealthResponse(data) &&
              data.hasura === "OK",
          );
        } catch {
          setIsBackendHealthy(false);
        }
      };

      checkHealth();

      const healthCheckInterval = setInterval(
        checkHealth,
        HEALTH_CHECK_INTERVAL_IN_MILLISECONDS,
      );

      return () => clearInterval(healthCheckInterval);
    }
  }, [isEnabled]);

  return { isBackendHealthy };
};

export { useBackendHealthService };
